import getScaleFromRes from '../utils/getScaleFromRes.js';
import Style from 'ol/style/Style.js';
import Chart from 'ol-ext/style/Chart.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Text from 'ol/style/Text.js';

export function buildPieChartSymbolizer(pointSymboliert, options, map) {
    var renderResolution = options['maprender'];
    var pieChartSymbolizers = [];
    var piechartMapStyle = JSON.parse(pointSymboliert['pieChart']);
    var pieChartSymbolizer = {
        kind: 'StyleFunction', visible: true, style: function (feature, o) {

            var style = null;
            if (!style) {

                var renderScale = renderResolution ? renderResolution : feature.get('renderScaleGrodan');
                var zuruu;

                if (renderScale != null) {
                    if (map != undefined) {
                        o = getScaleFromRes(map)
                    }
                    zuruu = parseFloat(renderScale) / o;
                } else {
                    if (map != undefined) {
                        o = getScaleFromRes(map)
                    }
                }

                var sum = 0;
                var data = [];
                var colors = piechartMapStyle.colors;

                piechartMapStyle.values.forEach(valueName => {
                    var value = feature.get(valueName) ? parseFloat(feature.get(valueName)) : 0;
                    data.push(value);
                    sum += value;
                });

                if (sum == 0) {
                    sum = Math.PI;
                    data = [Math.PI];
                    colors = ['rgba(0,0,0,0)'];
                }

                // area proportional to data size: s=PI*r^2
                var radius = piechartMapStyle.radius * Math.sqrt(sum / Math.PI);

                if (piechartMapStyle.staticRadius == true) {
                    radius = piechartMapStyle.radius;
                }

                radius = zuruu ? zuruu * radius : radius;

                var strokeWidth = zuruu ? zuruu * piechartMapStyle.strokeWidth : piechartMapStyle.strokeWidth;

                //radius *= (sel ? 1.2 : 1);
                // Create chart style
                style = [new Style({
                    image: new Chart({
                        type: "pie",
                        radius: radius,
                        data: data,
                        colors: colors,
                        rotateWithView: true,
                        stroke: new Stroke({
                            color: piechartMapStyle.strokeColor,
                            width: strokeWidth
                        }),
                    })
                })];

            }

            return style[0];
        },
        values: piechartMapStyle.values,
        colors: piechartMapStyle.colors,
        aliasname: pointSymboliert.aliasname,
    };

    pieChartSymbolizers.push(pieChartSymbolizer);

    var sel = piechartMapStyle.labelPieChart != 'none';

    if (sel) {

        piechartMapStyle.values.forEach((valueName, ind) => {

            var color = piechartMapStyle.colors[ind];

            try {
                var names = pointSymboliert.aliasname.split(',');
                if (names[ind]) {
                    valueName = names[ind];
                }
            } catch (e) {

            }

            pieChartSymbolizers.push({
                kind: 'StyleFunction', visible: true, color: color, name: valueName, style: function (feature, o) {

                    var renderScale = renderResolution ? renderResolution : feature.get('renderScaleGrodan');
                    var zuruu;

                    if (renderScale != null) {
                        if (map != undefined) {
                            o = getScaleFromRes(map)
                        }
                        zuruu = parseFloat(renderScale) / o;
                    } else {
                        if (map != undefined) {
                            o = getScaleFromRes(map)
                        }
                    }

                    var style = new Style();
                    var sum = 0;
                    var data = [];

                    piechartMapStyle.values.forEach((valueName_e, inde) => {
                        var aliasName = valueName_e;
                        var value = feature.get(valueName_e) ? parseFloat(feature.get(valueName_e)) : 0;

                        try {
                            var names = pointSymboliert.aliasname.split(',');
                            if (names[inde]) {
                                aliasName = names[inde];
                            }
                        } catch (e) {

                        }

                        if (feature.get(valueName_e + '_name')) {
                            aliasName = feature.get(valueName_e + '_name');
                        }

                        data.push({ value, valueName: aliasName });
                        sum += value;
                    });

                    // area proportional to data size: s=PI*r^2
                    var labelRadius = piechartMapStyle.radius * Math.sqrt(sum / Math.PI);

                    if (piechartMapStyle.staticRadius == true) {
                        labelRadius = parseInt(piechartMapStyle.radius);
                    }

                    labelRadius = zuruu ? zuruu * labelRadius : labelRadius;

                    var size = zuruu ? zuruu * 14 : 14;

                    var offsetPiechart = piechartMapStyle.offsetPiechart ? piechartMapStyle.offsetPiechart : 3;

                    offsetPiechart = zuruu ? zuruu * offsetPiechart : offsetPiechart;

                    var strokeWidth = zuruu ? zuruu * 1 : 1;

                    var s = 0;
                    for (var i = 0; i < data.length; i++) {
                        var d = data[i]['value'];
                        var e = data[i]['valueName'];
                        var a = (2 * s + d) / sum * Math.PI - Math.PI / 2;
                        var v = Math.round(d / sum * 1000);
                        if (v > 0) {
                            if (i == ind) {

                                var textN = `${e}: ` + (v / 10) + "%";

                                if (piechartMapStyle.labelPieChart == 'value') {
                                    textN = `${e}: ` + d.toString();
                                }

                                style = new Style({
                                    text: new Text({
                                        text: textN, /* d.toString() */
                                        offsetX: Math.cos(a) * (labelRadius + parseInt(offsetPiechart)),
                                        offsetY: Math.sin(a) * (labelRadius + parseInt(offsetPiechart)),
                                        textAlign: (a < Math.PI / 2 ? "left" : "right"),
                                        textBaseline: "middle",
                                        stroke: new Stroke({ color: piechartMapStyle.strokeColor, width: parseFloat(strokeWidth) }),
                                        fill: new Fill({ color: piechartMapStyle.color }),
                                        font: `${size}px Arial`,
                                    })
                                });
                            }

                        }
                        s += d;
                    }
                    return style;
                }
            });

        });

    }

    return pieChartSymbolizers;
}
